export default "__VITE_ASSET__Djv2or_R__"